import React from 'react';

import { Button } from '@/components/UI/Button';

import { LoadingSpinner, StatusContainer, StatusMessage } from './styles';

export type TableStatusKind = 'loading' | 'refreshing' | 'empty' | 'error';

interface TableStatusProps {
  status: TableStatusKind;
  message: string;
  retryLabel?: string;
  onRetry?: () => void;
  compact?: boolean;
  className?: string;
}

const TableStatus: React.FC<TableStatusProps> = ({
  status,
  message,
  retryLabel,
  onRetry,
  compact = false,
  className,
}) => {
  const isError = status === 'error';
  const isPending = status === 'loading' || status === 'refreshing';

  return (
    <StatusContainer
      className={className}
      role={isError ? 'alert' : 'status'}
      aria-live={isError ? 'assertive' : 'polite'}
      aria-atomic="true"
      $compact={compact}
      $status={status}
    >
      {isPending && <LoadingSpinner aria-hidden="true" $compact={compact} />}
      <StatusMessage>{message}</StatusMessage>
      {isError && onRetry && retryLabel && (
        <Button type="button" size="md" variant="primary" rounded={false} onClick={onRetry}>
          {retryLabel}
        </Button>
      )}
    </StatusContainer>
  );
};

export default TableStatus;
